// One identity rule also covers avatars in streams, cached components and later DOM patches.
// Keep both theme pairs so a theme switch still works after a profile update.
export function avatarProfileRule({id, avatar_style}) {
  if (!/^[a-zA-Z0-9_-]+$/.test(id || "") || typeof avatar_style !== "string") return ""
  const selector = `[data-user-avatar-id="${id}"]`
  const properties = avatar_style.split(";").filter(Boolean).map(property => `${property}!important`).join(";")
  return `${selector}{${properties};background-color:var(--user-avatar-bg)!important;color:var(--user-avatar-ink)!important}` +
    `html.dark ${selector},html[data-theme="dark"] ${selector}{background-color:var(--user-avatar-dark-bg)!important;color:var(--user-avatar-dark-ink)!important}`
}

export function installUserProfileSync(win = window, doc = document, socket) {
  if (win.__seivaUserProfileSync) return
  win.__seivaUserProfileSync = true
  const profiles = new Map()
  // A reconnect remounts views from the database; discard overrides from before it.
  socket?.onOpen(() => {
    profiles.clear()
    const stylesheet = doc.getElementById("seiva-live-user-avatars")
    if (stylesheet) stylesheet.textContent = ""
  })
  win.addEventListener("phx:user-profile-updated", ({detail}) => {
    const rule = avatarProfileRule(detail || {})
    if (!rule || profiles.get(detail.id) === rule) return
    profiles.set(detail.id, rule)
    let stylesheet = doc.getElementById("seiva-live-user-avatars")
    if (!stylesheet) {
      stylesheet = doc.createElement("style")
      stylesheet.id = "seiva-live-user-avatars"
      doc.head.appendChild(stylesheet)
    }
    stylesheet.textContent = Array.from(profiles.values()).join("\n")
  })
}
